import { render, staticRenderFns } from "./BrickLayout.vue?vue&type=template&id=174b9fa6&"
import script from "./BrickLayout.vue?vue&type=script&lang=js&"
export * from "./BrickLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports